export const getCloudflareImageUrl = (imageUrl, options) => {
  if (!imageUrl) return null;
  const fullImageUrl = imageUrl.startsWith("http")
    ? imageUrl
    : `https://${imageUrl}`;
  return `https://pozivnica.hr/cdn-cgi/image/${options}/${fullImageUrl}`;
};
